export class HttpUtils {

    static extractData(res: any): any {
        const body = res;
        return body;
    }

    /**
     * #31: el servidor devuelve el motivo de un rechazo como texto. Un 400 sin cuerpo llega como '' y
     * mostrarlo daba un aviso en blanco: solo cuenta como mensaje un texto no vacio.
     */
    static hasErrorMessage(err: any): boolean {
        return err != null && typeof err.error === 'string' && err.error.trim() !== '';
    }

}
